<template>
  <div class="reveal-on-hover">
    <div class="hidden bg-grey-dark with-tooltip rounded text-sm popup-left">
      <div class="popup-inner overflow-y-scroll">
        <div class="text-left p-2 text-white">
          <div class="flex flex-row items-center flex-1 border-white border-bottom p-2">
            <div class="flex flex-col text-left px-2">
              <p class="mb-2 md:text-sm uppercase text-lg">Include/Exclude</p>
            </div>
          </div>
          <div class="flex flex-row items-center items-center flex-1 p-2">
            <div class="flex flex-col w-1/3 text-left px-2 uppercase">
              Include All:
            </div>
            <div class="flex flex-col w-1/3 text-center px-2">
              <button class="rounded-full border bg-grey-light py-2 px-1 hover:bg-green hover:text-white" @click.prevent="$emit('include-all',true,'page')">On this page</button>
            </div>
            <div class="flex flex-col w-1/3 text-center px-2">
              <button class="rounded-full border bg-grey-light py-2 px-1 hover:bg-green hover:text-white" @click.prevent="$emit('include-all',true,'filter')">Filtered results</button>
            </div>
          </div>
          <div class="flex flex-row items-center flex-1 p-2">
            <div class="flex flex-col w-1/3 text-left px-2 uppercase">
              Exclude All:
            </div>
            <div class="flex flex-col w-1/3 text-center px-2">
              <button class="rounded-full border bg-grey-light py-2 px-1 hover:bg-green hover:text-white" @click.prevent="$emit('include-all',false,'page')">On this page</button>
            </div>
            <div class="flex flex-col w-1/3 text-center px-2">
              <button class="rounded-full border bg-grey-light py-2 px-1 hover:bg-green hover:text-white" @click.prevent="$emit('include-all',false,'filter')">Filtered results</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="underline mx-2">INCLUDE</div>
  </div>
</template>

<script>

export default {
  name: 'include-popover'
}
</script>

<style lang="sass" scoped>
.popup-left
  position: absolute
  right: 6em
  bottom: 0.5em
  z-index: 20

.popup-inner
  width: 450px
  height: auto
  max-height: 300px

.reveal-on-hover:hover > div
  display: block

.with-tooltip
    &::after, &::before
      content: ''
      width: 0
      height: 0

      position: absolute

      top: 80%
      right: -8px
      transform: translateY(-50%)

      border-top: 8px solid transparent
      border-bottom: 8px solid transparent

      border-left: 8px solid #8795a1
</style>
